import React from "react";

import { Box, Button, Typography } from "@mui/material";

import ParticlesBg from "./ParticlesBg";
import { LogoContainer } from "./styles";

import Logo from "../images/logo.svg";
import option1 from "./Particles/particles1";

const Hero = () => {
  return (
    <Box>
      <LogoContainer>
        <img src={Logo} alt="Futuristic Studio logo" style={logoStyles} />
        <Typography variant="subtitle1" color="common.white" textAlign="center">
          Lorem ipsum dolor sit amet. Et veritatis aperiam et omnis dolor qui
          voluptate autem aut commodi velit vel mollitia atque ab obcaecati
          doloremque est dolores tempora.
        </Typography>
        <Box>
          <Button>Learn More</Button>
        </Box>
      </LogoContainer>
      <Box>
        <ParticlesBg option={option1} />
      </Box>
    </Box>
  );
};

export default Hero;

const logoStyles = {
  width: "100%",
};
